import React from "react";
import { Skeleton } from "@mui/material";

export default function InventoryItemLoader() {
	return (
		<Skeleton height="75px" variant="rounded" sx={{ marginBottom: '10px' }}/>
	)
}